export default __webpack_public_path__ + "static/media/blue_plus.1498c6d0.svg";